webpackJsonp([4,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(216);
	module.exports = __webpack_require__(213);


/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	var config = {
	  scheme: 'release',
	  env: {
	    alpha: {
	      prefix: ''
	    },
	    beta: {
	      prefix: '/admin',
	      apiPath: '/apiPath',
	      basicUrl: 'http://dev.lvyuetravel.com:8080',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.lvyuetravel.com:8080/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    devx: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://dev.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://dev.www.aihuazhu.com',
	      imagesUrl: 'http://dev.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    test: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://test.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://test.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    integrate: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://www.integrate.lvyuetravel.com',
	      aihuazhuUrl: 'http://www.integrate.aihuazhu.com',
	      imagesUrl: 'http://static.integrate.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://static.integrate.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    production: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'https://www.lvyuetravel.com',
	      aihuazhuUrl: 'https://www.aihuazhu.com',
	      imagesUrl: 'https://static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'https://static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=production'
	    }
	  },
	  domains: {
	    urlStatic: '',
	    loginSite: 'http://test.www.lvyuetravel.com'
	  }
	};
	
	// 环境切换
	if (false) {
	  config.scheme = 'beta';
	} else if (false) {
	  config.scheme = 'devx';
	} else if (false) {
	  config.scheme = 'test';
	} else if (false) {
	  config.scheme = 'integrate';
	} else if (true) {
	  config.scheme = 'production';
	}
	module.exports = config;

/***/ },

/***/ 2:
/***/ function(module, exports) {

	var language = 'zh-CN';
	if (window.location.search.indexOf('locale=USA') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=en') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=JP') > -1) {
	  language = 'JP';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=KO') > -1) {
	  language = 'KO';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=TH') > -1) {
	  language = 'TH';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
	  language = 'zh-CN';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=YH') > -1) {
	  language = 'YH';
	  localStorage.setItem('language', language);
	} else {
	  localStorage.setItem('language', language);
	}
	
	module.exports = { language: language };

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	
	
	var config = __webpack_require__(1);
	config = config.env[config.scheme];
	// var xecond= config.env[config.scheme].senCond
	(function (para) {
	  //神策
	  var p = para.sdk_url,
	      n = para.name,
	      w = window,
	      d = document,
	      s = 'script',
	      x = null,
	      y = null;
	  w['sensorsDataAnalytic201505'] = n;
	  w[n] = w[n] || function (a) {
	    return function () {
	      (w[n]._q = w[n]._q || []).push([a, arguments]);
	    };
	  };
	  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
	  for (var i = 0; i < ifs.length; i++) {
	    w[n][ifs[i]] = w[n].call(null, ifs[i]);
	  }
	  if (!w[n]._t) {
	    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
	    x.async = 1;
	    x.src = p;
	    w[n].para = para;
	    y.parentNode.insertBefore(x, y);
	  }
	})({
	  sdk_url: config.senCondjs,
	  name: 'sensors',
	  server_url: config.senCond,
	  // server_url:' http://shence.lvyuetravel.com:8107',
	  cross_subdomain: true,
	  heatmap: {
	    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
	    clickmap: 'default',
	    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
	    scroll_notice_map: 'not_collect'
	  }
	});
	sensors.registerPage({ platformType: 'pc' });
	sensors.quick('autoTrack'); //神策系统必须是1.4最新版及以上

/***/ },

/***/ 4:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 5:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 6:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 7:
/***/ function(module, exports, __webpack_require__) {

	//预搜索
	window.destinationInitVal = $('input[name="regionName"]').val(); //为使用预搜索失去焦点时使用
	var Config = __webpack_require__(1);
	var apiPath = Config.env[Config.scheme].apiPath;
	var aihuazhuUrl = Config.env[Config.scheme].aihuazhuUrl;
	__webpack_require__(3);
	function preSearch(date, clickDestinationCallback, brandSeries) {
	  $(document).on('click.closeDest', function (e) {
	    var $this = $('.pre-search');
	    //有匹配的城市或景点显示匹配的第一个，没有则显示默认的
	    var locations = $('.pre-search .locations');
	    if (locations.length) {
	      destinationInitVal = locations.eq(0).data('locations');
	      var obj = {
	        name: locations.eq(0).data('locations'),
	        id: locations.eq(0).data('cityid'),
	        type: locations.eq(0).data('type')
	      };
	      clickDestinationCallback(obj);
	    }
	
	    $('input[name="regionName"]').val(destinationInitVal);
	    if ($this.find($(e.target)).length > 0 || $this[0] === e.target) return;
	    setTimeout(function () {
	      $('.pre-search').remove();
	    }, 30);
	  });
	  var bind_name = 'input';
	  if (navigator.userAgent.indexOf("MSIE") != -1) {
	    bind_name = 'propertychange';
	  }
	  $('input[name="regionName"]').bind(bind_name, function () {
	    var inputVal = $(this).val();
	    if (!inputVal.length) {
	      $('.hot-city-model').hide();
	      $('.pre-search').remove();
	      return false;
	    }
	
	    var ajaxUrl,
	        data = {
	      param: inputVal,
	      checkIn: date.checkIn,
	      pn: 1,
	      checkOut: date.checkOut,
	      ps: 50
	    };
	
	    if (brandSeries) {
	      ajaxUrl = apiPath + '/api/hotel/pre_brand_search.json';
	      data.brandSeries = brandSeries;
	    } else {
	      ajaxUrl = apiPath + '/api/hotel/pre_search.json';
	    }
	    $.ajax({
	      //版本号
	      headers: {
	        ver: 206
	      },
	      url: ajaxUrl,
	      type: 'GET',
	      cache: false,
	      data: data,
	      success: function (res) {
	        $('.hot-city-model').hide();
	
	        if (res.success) {
	          var backHtmlWrap = '<ul class="pre-search" style="top:' + ($('.destination').outerHeight() + 2) + 'px"></ul>';
	          var preSearchDiv = $('.pre-search');
	          preSearchDiv.length ? preSearchDiv.show() : $('.destination').append(backHtmlWrap);
	
	          var backHtml = '';
	          if (res.total == 0) {
	            backHtml += '<p>很抱歉没有搜索到匹配结果，换个词试试</p>';
	          } else {
	            for (var i = 0; i < res.data.locations.length; i++) {
	              var item = res.data.locations[i];
	              if (item.type == 2) {
	                //城市
	                backHtml += '<li class="locations locationsCity" data-locations="' + item.cityName + '" data-type="' + item.type + '" data-cityid="' + item.city + '"><span>' + item.highlightCityName + ',' + item.provinceName + '</span><span>城市</span></li>';
	              }
	              if (item.type == 3) {
	                //景点
	                backHtml += '<li class="locations locationsSpot" data-locations="' + item.cityName + '" data-type="' + item.type + '" data-landmarkid="' + item.landmarkId + '" data-land="' + item.landmarkName + '"><span>' + item.highlightLandmark + ',' + item.provinceName + '</span><span>景点</span></li>';
	              }
	            }
	            for (var i = 0; i < res.data.hotels.length; i++) {
	              var item = res.data.hotels[i];
	              backHtml += '<li class="hotels"><a href="javascript:void(0);" data-id="' + item.id + '">' + (item.highlightName || item.name) + '</a><span>酒店</span></li>';
	            }
	          }
	          $('.pre-search').html(backHtml);
	
	          $('.pre-search').find('a').click(function () {
	            window.open(aihuazhuUrl + '/detail/' + $(this).data('id'));
	          });
	          //点击城市
	          $('.pre-search').find('.locationsCity').click(function () {
	            setTimeout(function () {
	              $('.pre-search').remove();
	            }, 0);
	            var obj = {
	              name: $(this).data('locations'),
	              id: $(this).data('cityid'),
	              type: $(this).data('type')
	            };
	            clickDestinationCallback(obj);
	          });
	          //点击景点
	          $('.pre-search').find('.locationsSpot').click(function () {
	            setTimeout(function () {
	              $('.pre-search').remove();
	            }, 0);
	            var obj = {
	              name: $(this).data('land'),
	              id: $(this).data('landmarkid'),
	              type: $(this).data('type')
	            };
	
	            clickDestinationCallback(obj);
	          });
	        } else {}
	      }
	    });
	  });
	}
	
	exports.preSearch = preSearch;

/***/ },

/***/ 213:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// var language = localStorage.getItem('language') || 'zh-CN';
	
	__webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	// var languageType = require('./languageCommon.js')
	// var language = languageType.language;
	
	
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(6);
	__webpack_require__(236);
	__webpack_require__(5);
	// if (window.location.search.indexOf('lang=En') > -1) {
	//     language = 'USA';
	//     localStorage.setItem('language', 'USA')
	// }
	if (language == 'zh-CN') {
	    $('body').removeClass('en');
	} else {
	    //如果是英文进入该页面，重定向到外文首页
	    window.location.href = '/indexForeign.html?locale=' + language;
	    $('body').addClass('en');
	}
	var preS = __webpack_require__(7);
	var preSearch = preS.preSearch;
	var Config = __webpack_require__(1);
	var url_prefix = Config.env[Config.scheme].prefix;
	var apiPath = Config.env[Config.scheme].apiPath;
	var aihuazhuUrl = Config.env[Config.scheme].aihuazhuUrl;
	$("img").on('dragstart', function () {
	    return false;
	});
	
	$('.commonHomePage').addClass('select');
	$('.reservationCode .close ,.reservationCode .guanbi').on('click', function () {
	    $('.reservationCode').fadeOut(300);
	    $('.reservation').css('opacity', 1);
	});
	
	$(".about1").on('mouseover', function () {
	    $(".aboutLv").show();
	});
	$(".about1").on('mouseout', function () {
	    $(".aboutLv").hide();
	});
	$(".brand1").on('mouseover', function () {
	    $(".choiceBrand").show();
	}).on('mouseout', function () {
	    $(".choiceBrand").hide();
	});
	$('.language').on('mouseover', function () {
	    $(".choicelanguage").show();
	}).on('mouseout', function () {
	    $(".choicelanguage").hide();
	});
	$('.choicelanguage a').eq(0).on('click', function () {
	    console.log(window.location);
	    window.location.href = window.location.origin + window.location.pathname + '?locale=zh-CN';
	    localStorage.setItem('language', 'zh-CN');
	    if (window.location.search.indexOf('lang=En') > -1) {
	        window.location.href = '/';
	        return;
	    }
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(1).on('click', function () {
	    localStorage.setItem('language', 'USA');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=USA';
	});
	$('.choicelanguage a').eq(2).on('click', function () {
	    localStorage.setItem('language', 'JP');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=JP';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(3).on('click', function () {
	    localStorage.setItem('language', 'KO');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=KO';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(4).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=TH';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(5).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=YH';
	    //window.location.reload();
	});
	var sliderRowStep = 0;
	var $oImgs = $('.swiper_row .slider');
	function autoMove() {
	    sliderRowStep++;
	    sliderRowStep > 3 ? sliderRowStep = 0 : null; //当显示最后一张，下一次让outer.step变为0
	    $oImgs.eq(sliderRowStep).fadeIn(2500).siblings().fadeOut(2500);
	}
	setInterval(autoMove, 4000);
	
	$(".submitInfo_submit").on("click", submitInfo);
	
	function submitInfo() {
	    if (!$(".submitInfo_name").val()) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputName[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if ($(".submitInfo_name").val().length > 50) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputNameLong[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if ($(".submitInfo_address").val().length > 50) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressLong[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if (!/^1[34578]\d{9}$/.test($(".submitInfo_phone").val())) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputPhoneError[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if (!$(".submitInfo_address").val()) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressError[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    $(".submitInfo_submit").off("click", submitInfo);
	    sensors.track("formSubmit", { "name": $('.submitInfo_name').val(), 'phone_number': $(".submitInfo_phone").val(), 'address': $(".submitInfo_address").val(), 'form_entrance': 'PC首页'
	    });
	    $.ajax({
	        url: url_prefix + '/mng/api/pcms/league/create.json',
	        type: 'POST',
	        data: {
	            name: $(".submitInfo_name").val(),
	            mobile: $(".submitInfo_phone").val(),
	            address: $(".submitInfo_address").val(),
	            dataSource: 1
	        },
	        dataType: 'json',
	        timeout: 5000,
	        success: function (res) {
	            if (res.success) {
	                $(".submitInfo_tips_1").html(commonCompanyCubmitSuccess[language]);
	                $(".submitInfo_tips_1").show();
	                $(".submitInfo_name").val("");
	                $(".submitInfo_phone").val("");
	                $(".submitInfo_address").val("");
	                $(".submitInfo_input_joinUs").html(homePageSwiperFiveJoin[language]);
	                setTimeout(function () {
	                    $(".submitInfo_tips_1").hide();
	                    $(".submitInfo_submit").on("click", submitInfo);
	                }, 1500);
	            } else {
	                $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
	                $(".submitInfo_tips_1").show();
	                setTimeout(function () {
	                    $(".submitInfo_tips_1").hide();
	                    $(".submitInfo_submit").on("click", submitInfo);
	                }, 1500);
	            }
	        },
	        error: function (error) {
	            $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
	            $(".submitInfo_tips_1").show();
	            setTimeout(function () {
	                $(".submitInfo_tips_1").hide();
	                $(".submitInfo_submit").on("click", submitInfo);
	            }, 1500);
	            $(".submitInfo_submit").on("click", submitInfo);
	        }
	    });
	}
	
	//判断是否是IE浏览器，包括Edge浏览器
	function IEVersion() {
	    var isOpera = navigator.userAgent.indexOf("Opera") > -1;
	    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
	    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
	    var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
	    if (isIE) {
	        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
	        reIE.test(userAgent);
	        var fIEVersion = parseFloat(RegExp["$1"]);
	        if (fIEVersion == 7) {
	            return "IE7";
	        } else if (fIEVersion == 8) {
	            return "IE8";
	        } else if (fIEVersion == 9) {
	            return "IE9";
	        } else if (fIEVersion == 10) {
	            return "IE10";
	        } else if (fIEVersion == 11) {
	            return "IE11";
	        } else {
	            return "0";
	        } //IE版本过低
	    } else if (isEdge) {
	        return "Edge";
	    } else {
	        return "-1"; //非IE
	    }
	}
	
	function placeholderSupport() {
	    return 'placeholder' in document.createElement('input');
	}
	
	function placeholder(target) {
	
	    $(target).val($(target).attr("datavalue")).addClass("inp");
	    $(target).focus(function () {
	        if ($(this).val() == $(this).attr("datavalue")) {
	            $(this).val("").removeClass("inp");
	        }
	    });
	    $(target).blur(function () {
	        if ($(this).val() == "" || $(this).val() == $(this).attr("datavalue")) {
	            $(this).val($(target).attr("datavalue")).addClass("inp");
	        }
	    });
	}
	
	if (!placeholderSupport()) {
	
	    placeholder(".submitInfo_name");
	    placeholder(".submitInfo_phone");
	    placeholder(".submitInfo_address");
	    placeholder(".ipt");
	}
	
	var animateIndex = 0;
	var timer2 = setInterval(function () {
	    animateIndex++;
	    if (animateIndex > 10) {
	        animateIndex = 0;
	    }
	    $(".animate1").eq(animateIndex).addClass("animate2").siblings().removeClass("animate2");
	}, 6000);
	
	$(".animate").on("mouseover", function () {
	    $(".animate1").removeClass("animate2");
	    clearInterval(timer2);
	});
	$(".animate").on("mouseout", function () {
	    $(".animate1").eq(animateIndex).addClass("animate2");
	    timer2 = setInterval(function () {
	        animateIndex++;
	        if (animateIndex > 10) {
	            animateIndex = 0;
	        }
	        $(".animate1").eq(animateIndex).addClass("animate2").siblings().removeClass("animate2");
	    }, 6000);
	});
	
	$('.column_slider3_flower').on('click', function () {
	    $('.column_slider3_flower .select').addClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_arula .select').removeClass('select2');
	    $('.column_slider3_Banlan .select').removeClass('select2');
	
	    $(".column_slider3_flower").addClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_arula").removeClass("selcet_color");
	    $('.column_slider3_Banlan').removeClass('selcet_color');
	
	    $('.column_slider_3_Info_floral').show();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Banlan').hide();
	
	    $('.column_slider_3_Info_arula').hide();
	    $(".column_slider3_container").removeClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").addClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").removeClass("column_slider3_container_Banlan");
	});
	$('.column_slider3_floral_lux').on('click', function () {
	    $('.column_slider3_flower .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').addClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_arula .select').removeClass('select2');
	    $('.column_slider3_Banlan .select').removeClass('select2');
	
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").addClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_arula").removeClass("selcet_color");
	    $('.column_slider3_Banlan').removeClass('selcet_color');
	
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').show();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Banlan').hide();
	
	    $('.column_slider_3_Info_arula').hide();
	    $(".column_slider3_container").removeClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").addClass("column_slider3_container_floral_lux");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").removeClass("column_slider3_container_Banlan");
	});
	$('.column_slider3_suoxin').on('click', function () {
	    $('.column_slider3_flower .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').addClass('select2');
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_arula .select').removeClass('select2');
	    $('.column_slider3_Banlan .select').removeClass('select2');
	
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_sucha').show();
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Banlan').hide();
	
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxin").addClass("selcet_color");
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_arula").removeClass("selcet_color");
	    $(".column_slider3_Banlan").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_arula').hide();
	    $(".column_slider3_container").removeClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").addClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").removeClass("column_slider3_container_Banlan");
	});
	$('.column_slider3_vyluk').on('click', function () {
	    $('.column_slider3_vyluk .select').addClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_arula .select').removeClass('select2');
	    $('.column_slider3_Banlan .select').removeClass('select2');
	
	    $(".column_slider3_vyluk").addClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_arula").removeClass("selcet_color");
	    $(".column_slider3_Banlan").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').show();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Banlan').hide();
	
	    $('.column_slider_3_Info_arula').hide();
	    $(".column_slider3_container").removeClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").addClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").removeClass("column_slider3_container_Banlan");
	});
	$('.column_slider3_suoxingChoice').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').addClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_arula .select').removeClass('select2');
	    $('.column_slider3_Banlan .select').removeClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").addClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_arula").removeClass("selcet_color");
	    $(".column_slider3_Banlan").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').show();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Banlan').hide();
	
	    $('.column_slider_3_Info_arula').hide();
	    $(".column_slider3_container").removeClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").addClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").removeClass("column_slider3_container_Banlan");
	});
	$('.column_slider3_URBA').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').addClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_arula .select').removeClass('select2');
	    $('.column_slider3_Banlan .select').removeClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").addClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_arula").removeClass("selcet_color");
	    $(".column_slider3_Banlan").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').show();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Banlan').hide();
	
	    $('.column_slider_3_Info_arula').hide();
	    $(".column_slider3_container").removeClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").addClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").removeClass("column_slider3_container_Banlan");
	});
	
	$('.column_slider3_arula').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_arula .select').addClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_Banlan .select').removeClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_arula").addClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_Banlan").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	
	    $('.column_slider_3_Info_arula').show();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Banlan').hide();
	
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").addClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").removeClass("column_slider3_container_Banlan");
	});
	
	$('.column_slider3_BeU').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').addClass('select2');
	    $('.column_slider3_arula .select').removeClass('select2');
	    $('.column_slider3_Banlan .select').removeClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").addClass("selcet_color");
	    $(".column_slider3_arula").removeClass("selcet_color");
	    $(".column_slider3_Banlan").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').show();
	    $('.column_slider_3_Info_Banlan').hide();
	
	    $('.column_slider_3_Info_arula').hide();
	    $(".column_slider3_container").removeClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").addClass("column_slider3_container_BeU");
	    $(".column_slider3_container").removeClass("column_slider3_container_Banlan");
	});
	
	$('.column_slider3_Banlan').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_arula .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_arula .select').addClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_arula").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_Banlan").addClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	
	    $('.column_slider_3_Info_arula').hide();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Banlan').show();
	
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider_3_Info_arula");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").addClass("column_slider3_container_Banlan");
	});
	
	$(function () {
	    $.ajax({
	        url: apiPath + '/api/hotel/hot_dests_and_cities.json',
	        type: 'GET',
	        cache: false,
	        data: {
	            client: 'app'
	        },
	        success: function (res) {
	            if (res.success) {
	                window.hotCityObj = res.data;
	                destination('inland');
	            }
	        }
	    });
	    preSearch({
	        checkIn: $('input[data-selector="checkIn"]').val(),
	        checkOut: $('input[data-selector="checkOut"]').val()
	    }, clickDestinationCallback);
	
	    $('.member_btn a').click(function () {
	        window.open(aihuazhuUrl + $(this).data('href'));
	    });
	});
	
	// 目的地 弹窗
	function destination(key) {
	    $('[data-selector="destination"]').destination({
	        data: hotCityObj,
	        key: key,
	        hot: true,
	        mapKey: ['ABCD', 'EFGH', 'JKLM', 'NOPQRS', 'TUVWX', 'YZ'],
	        clickCallBack: function (obj) {
	            clickDestinationCallback(obj);
	        }
	    });
	}
	
	function clickDestinationCallback(obj) {
	    $('[name="regionId"]').val(obj.id);
	    $('[name="regionName"]').val(obj.name);
	    $('input[name="regionType"]').val(obj.type);
	    destinationInitVal = obj.name; //默认显示的目的地的值
	    var timeObj = getTime(obj.id, true, hotCityObj);
	    setDatepickInit(timeObj);
	}
	
	$(document).on('submit', '[data-selector="search-hotel"]', function () {
	    var cityId = $('input[name="regionId"]').val();
	    var regionType = $('input[name="regionType"]').val();
	    var startDay = $('input[data-selector="checkIn"]').val();
	    var endDay = $('input[data-selector="checkOut"]').val();
	    window.open(aihuazhuUrl + '/list/' + regionType + '/' + cityId + '?startDay=' + startDay + '&endDay=' + endDay);
	    return false;
	});

/***/ },

/***/ 216:
/***/ function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	var languageType = __webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	if (window.location.search.indexOf('lang=En') > -1) {
	    language = 'USA';
	    localStorage.setItem('language', 'USA');
	}
	
	$('.commonlanguage').html(commonlanguage[language]);
	$('title').html(homePageTitle[language]);
	$('.commonHomePage').html(commonHomePage[language]);
	$('.commonLvyue').html(commonLvyue[language]);
	$('.commonAboutLvyue').html(commonAboutLvyue[language]);
	$('.commonflowerTravel').html(commonflowerTravel[language]);
	$('.commonlvyueBrand').html(commonlvyueBrand[language]);
	$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
	$('.commonFloralLux').html(commonFloralLux[language]);
	$('.commonClaim').html(commonClaim[language]);
	$('.commonClaimChoice').html(commonClaimChoice[language]);
	$('.commonWeiLai').html(commonWeiLai[language]);
	$('.commonTanChen').html(commonTanChen[language]);
	$('.commonBaina').html(commonBaina[language]);
	$('.commonBanlan').html(commonBanlan[language]);
	$('.commonBeu').html(commonBeu[language]);
	$('.subhtml').html(subhtml[language]);
	$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
	$('.commonPanorama').html(commonPanorama[language]);
	// $('.commonPaidInformation').html(commonPaidInformation[language]);
	$('.commonZh').html(commonZh[language]);
	$('.commonUsa').html(commonUsa[language]);
	$('.commonJp').html(commonJp[language]);
	$('.commonKo').html(commonKo[language]);
	$('.commonTh').html(commonTh[language]);
	$('.commonYh').html(commonYh[language]);
	$('.commonReservations a').html(commonReservations[language]);
	$('.commonClose').html(commonClose[language]);
	$('.commonFreebooking').html(commonFreebooking[language]);
	$('.commonDownload').html(commonDownload[language]);
	$('.commonWechatSubscription').html(commonWechatSubscription[language]);
	$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
	$('.commonBrandintroductio').html(commonBrandintroductio[language]);
	$('.commonWantJoin').html(commonWantJoin[language]);
	$('.commonConectUs').html(commonConectUs[language]);
	$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
	$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
	$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
	$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
	$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
	$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
	$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
	$('.commonCompanyInfo').html(commonCompanyInfo[language]);
	$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
	$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
	$('.commonCompanyLicense').html(commonCompanyLicense[language]);
	$('.commonCompanyICP').html(commonCompanyICP[language]);
	$('.homePageSwiperOneTitle').html(homePageSwiperOneTitle[language]);
	$('.homePageSwiperTwoTitle').html(homePageSwiperTwoTitle[language]);
	$('.homePageSwiperThreeTitle').html(homePageSwiperThreeTitle[language]);
	$('.homePageSwiperThreeInfo').html(homePageSwiperThreeInfo[language]);
	$('.homePageSwiperThreeOpenedArea').html(homePageSwiperThreeOpenedArea[language]);
	$('.homePageSwiperTobeOpenedArea').html(homePageSwiperTobeOpenedArea[language]);
	$('.homePageSwiperThreeKohSamui').html(homePageSwiperThreeKohSamui[language]);
	$('.homePageSwiperThreeBeijing').html(homePageSwiperThreeBeijing[language]);
	$('.homePageSwiperThreeNanjing').html(homePageSwiperThreeNanjing[language]);
	$('.homePageSwiperThreeMoganmountain').html(homePageSwiperThreeMoganmountain[language]);
	$('.homePageSwiperThreeNanxun').html(homePageSwiperThreeNanxun[language]);
	$('.homePageSwiperThreeAnji').html(homePageSwiperThreeAnji[language]);
	$('.homePageSwiperThreeChiangmai').html(homePageSwiperThreeChiangmai[language]);
	$('.homePageSwiperThreeSeoul').html(homePageSwiperThreeSeoul[language]);
	$('.homePageSwiperThreeXishuangbanna').html(homePageSwiperThreeXishuangbanna[language]);
	$('.homePageSwiperThreeDali').html(homePageSwiperThreeDali[language]);
	$('.homePageSwiperThreeLijiang').html(homePageSwiperThreeLijiang[language]);
	$('.homePageSwiperThreeChongqie').html(homePageSwiperThreeChongqie[language]);
	$('.homePageSwiperThreeLangzhonge').html(homePageSwiperThreeLangzhonge[language]);
	$('.homePageSwiperThreeGuohuang').html(homePageSwiperThreeGuohuang[language]);
	$('.homePageSwiperThreeLibo').html(homePageSwiperThreeLibo[language]);
	$('.homePageSwiperThreeZhangjiajie').html(homePageSwiperThreeZhangjiajie[language]);
	$('.homePageSwiperThreeHuangshan').html(homePageSwiperThreeHuangshan[language]);
	$('.homePageSwiperThreeHangzhou').html(homePageSwiperThreeHangzhou[language]);
	$('.homePageSwiperThreeChejudo').html(homePageSwiperThreeChejudo[language]);
	$('.homePageSwiperThreeFenghuang').html(homePageSwiperThreeFenghuang[language]);
	$('.homePageSwiperThreeSemporna').html(homePageSwiperThreeSemporna[language]);
	$('.homePageSwiperThreeWuzhen').html(homePageSwiperThreeWuzhen[language]);
	$('.homePageSwiperThreeSuzhou').html(homePageSwiperThreeSuzhou[language]);
	$('.homePageSwiperThreeGuilin').html(homePageSwiperThreeGuilin[language]);
	$('.homePageSwiperThreeWulong').html(homePageSwiperThreeWulong[language]);
	$('.homePageSwiperThreeXian').html(homePageSwiperThreeXian[language]);
	$('.homePageSwiperThreePingyao').html(homePageSwiperThreePingyao[language]);
	$('.homePageSwiperThreeXiamen').html(homePageSwiperThreeXiamen[language]);
	$('.homePageSwiperThreeLishui').html(homePageSwiperThreeLishui[language]);
	$('.homePageSwiperThreeXitang').html(homePageSwiperThreeXitang[language]);
	$('.homePageSwiperThreeSingapore').html(homePageSwiperThreeSingapore[language]);
	$('.homePageSwiperThreeKualaLumpur').html(homePageSwiperThreeKualaLumpur[language]);
	$('homePageSwiperThreePenang').html(homePageSwiperThreePenang[language]);
	$('.homePageSwiperThreePhuket').html(homePageSwiperThreePhuket[language]);
	$('.homePageSwiperThreeLangkawi').html(homePageSwiperThreeLangkawi[language]);
	$('.homePageSwiperThreePhnomPenh').html(homePageSwiperThreePhnomPenh[language]);
	$('.homePageSwiperThreeKotaKinabalu').html(homePageSwiperThreeKotaKinabalu[language]);
	$('.homePageSwiperThreePattaya').html(homePageSwiperThreePattaya[language]);
	$('.homePageSwiperThreeBangkok').html(homePageSwiperThreeBangkok[language]);
	$('.homePageSwiperThreeSiemReap').html(homePageSwiperThreeSiemReap[language]);
	$('.homePageSwiperThreeNhaTrang').html(homePageSwiperThreeNhaTrang[language]);
	$('.homePageSwiperThreeDaNang').html(homePageSwiperThreeDaNang[language]);
	$('.homePageSwiperThreeCebu').html(homePageSwiperThreeCebu[language]);
	$('.homePageSwiperThreeBoracayIsland').html(homePageSwiperThreeBoracayIsland[language]);
	$('.homePageSwiperThreeManila').html(homePageSwiperThreeManila[language]);
	$('.homePageSwiperThreeHanoi').html(homePageSwiperThreeHanoi[language]);
	$('.homePageSwiperThreeHongKong').html(homePageSwiperThreeHongKong[language]);
	$('.homePageSwiperThreeKaohsiung').html(homePageSwiperThreeKaohsiung[language]);
	$('.homePageSwiperThreeHualian').html(homePageSwiperThreeHualian[language]);
	$('.homePageSwiperThreeTaipei').html(homePageSwiperThreeTaipei[language]);
	$('.homePageSwiperThreeTengchong').html(homePageSwiperThreeTengchong[language]);
	$('.homePageSwiperThreeShangriLa').html(homePageSwiperThreeShangriLa[language]);
	$('.homePageSwiperThreeWuyiMount').html(homePageSwiperThreeWuyiMount[language]);
	$('.homePageSwiperThreeJiaxing').html(homePageSwiperThreeJiaxing[language]);
	$('.homePageSwiperThreeRizhao').html(homePageSwiperThreeRizhao[language]);
	$('.homePageSwiperThreeBusan').html(homePageSwiperThreeBusan[language]);
	$('.homePageSwiperThreeRizhao').html(homePageSwiperThreeRizhao[language]);
	$('.homePageSwiperThreeOsaka').html(homePageSwiperThreeOsaka[language]);
	$('.homePageSwiperThreeTokyo').html(homePageSwiperThreeTokyo[language]);
	$('.homePageSwiperThreekyoto').html(homePageSwiperThreekyoto[language]);
	$('.homePageSwiperThreeXinzhou').html(homePageSwiperThreeXinzhou[language]);
	$('.homePageSwiperFourTitle').html(homePageSwiperFourTitle[language]);
	$('.homePageSwiperFourBrandintroduction').html(homePageSwiperFourBrandintroduction[language]);
	$('.homePageSwiperFourDesignidea').html(homePageSwiperFourDesignidea[language]);
	$('.homePageSwiperFourDesignideaInfo1').html(homePageSwiperFourDesignideaInfo1[language]);
	$('.homePageSwiperFourSite').html(homePageSwiperFourSite[language]);
	$('.homePageSwiperFourView').html(homePageSwiperFourView[language]);
	$('.homePageSwiperFourVacation').html(homePageSwiperFourVacation[language]);
	$('.homePageSwiperFourBusinesstrip').html(homePageSwiperFourBusinesstrip[language]);
	$('.homePageSwiperFourDesignideaInfo3').html(homePageSwiperFourDesignideaInfo3[language]);
	$('.homePageSwiperFourBusinesstrip').html(homePageSwiperFourBusinesstrip[language]);
	$('.homePageSwiperFourDesignideaInfo2').html(homePageSwiperFourDesignideaInfo2[language]);
	$('.homePageSwiperFourTourismVacationSocialBusiness').html(homePageSwiperFourTourismVacationSocialBusiness[language]);
	
	$('.homePageSwiperFourDesignideaInfo4').html(homePageSwiperFourDesignideaInfo4[language]);
	$('.homePageSwiperFourMotto4').html(homePageSwiperFourMotto4[language]);
	$('.homePageSwiperFourDesignideaInfo5').html(homePageSwiperFourDesignideaInfo5[language]);
	$('.homePageSwiperFourMotto5').html(homePageSwiperFourMotto5[language]);
	$('.homePageSwiperFourDesignideaInfo6').html(homePageSwiperFourDesignideaInfo6[language]);
	$('.homePageSwiperFourDesignideaInfo7').html(homePageSwiperFourDesignideaInfo7[language]);
	$('.homePageSwiperFourMotto6').html(homePageSwiperFourMotto6[language]);
	$('.homePageSwiperFourMotto7').html(homePageSwiperFourMotto7[language]);
	
	$('.homePageSwiperFiveJointheInformation').html(homePageSwiperFiveJointheInformation[language]);
	$('.homePageSwiperFiveJointheInformation').attr('placeholder', homePageSwiperFiveJointheInformation[language]);
	$('.homePageSwiperFiveGirl').html(homePageSwiperFiveGirl[language]);
	$('.homePageSwiperFiveBoy').html(homePageSwiperFiveBoy[language]);
	$('.homePageSwiperFiveInputPhone').attr('placeholder', homePageSwiperFiveInputPhone[language]);
	$('.homePageSwiperFiveInputPhone').attr('datavalue', homePageSwiperFiveInputPhone[language]);
	$('.homePageSwiperFiveInputSpace').attr('placeholder', homePageSwiperFiveInputSpace[language]);
	$('.homePageSwiperFiveInputSpace').attr('datavalue', homePageSwiperFiveInputSpace[language]);
	$('.homePageSwiperFiveJoin').html(homePageSwiperFiveJoin[language]);
	$('.homePageSwiperFiveMaterialcooperation').html(homePageSwiperFiveMaterialcooperation[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('placeholder', homePageSwiperFiveJoinRemarkTips[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue', homePageSwiperFiveJoinRemarkTips[language]);
	$('.homePageSwiperFiveInputName').attr('placeholder', homePageSwiperFiveInputName[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue', homePageSwiperFiveInputName[language]);
	$('.homePageSwiperFiveInputName').html(homePageSwiperFiveInputName[language]);
	$('.homePageSwiperThreePenang').html(homePageSwiperThreePenang[language]);
	$('.commonLvyue1').html(commonLvyue1[language]);
	$('.Leadership').html(Leadership[language]);
	$('.TalentRecruitment').html(TalentRecruitment[language]);
	$('.floralReservation').html(floralReservation[language]);
	
	$('.commonBaina').html(commonBaina[language]);
	$('.commonBanlan').html(commonBanlan[language]);

/***/ },

/***/ 236:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }

});


/** WEBPACK FOOTER **
 ** js/index.94cf8b3f.js
 **/